export default __webpack_public_path__ + "static/media/5.30b288cd.png";